import React, { useState } from 'react'
import { useNoKeyboardResize } from '../hooks/useNoKeyboardResize'
import { useNavigate } from 'react-router-dom'
import AppBar from '../components/AppBar'
import SubmitButton from '../components/SubmitButton'
import FormTextarea from '../components/FormTextarea'
import { reviewKeywordApi } from '../api/reviewKeyword'
import toastUtil from '../utils/toast'

const MAX_LENGTH = 300

const ReviewKeywordSuggest: React.FC = () => {
  const navigate = useNavigate()
  useNoKeyboardResize()
  const [suggestionText, setSuggestionText] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleBack = () => {
    // 뒤로가기 (저장하지 않음)
    navigate(-1)
  }

  const handleSubmit = async () => {
    const trimmedText = suggestionText.trim()

    if (!trimmedText) {
      toastUtil.warning('제안 내용을 입력해주세요')
      return
    }

    if (trimmedText.length > MAX_LENGTH) {
      toastUtil.warning(`제안 내용은 최대 ${MAX_LENGTH}자까지 가능합니다`)
      return
    }

    setIsSubmitting(true)
    try {
      await reviewKeywordApi.suggestKeyword({
        suggestionText: trimmedText,
      })
      toastUtil.success('제안이 완료되었습니다')
      navigate(-1)
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || '제안 등록 중 오류가 발생했습니다'
      toastUtil.error(errorMessage)
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value
    if (newValue.length <= MAX_LENGTH) {
      setSuggestionText(newValue)
    }
  }

  const isFormValid = suggestionText.trim().length > 0

  return (
    <div className="w-full h-full flex flex-col bg-backgroundColorBg2">
      <div className="app-container flex-1 flex flex-col overflow-hidden pb-32px">
        {/* AppBar */}
        <AppBar title="키워드 추가" isBottomBorder onBack={handleBack} />

        {/* 컨텐츠 영역 */}
        <div className="flex-1 overflow-y-auto scrollbar-hide px-20px pb-24px">
          <div className="mt-16px">
            <FormTextarea
              name="suggestionText"
              value={suggestionText}
              onChange={handleTextChange}
              placeholder="찾으시는 키워드가 없다면 제안해보세요"
              maxLength={MAX_LENGTH}
            />
          </div>
        </div>

        {/* 하단 버튼 */}
        <div className="px-20px">
          <SubmitButton
            text="완료"
            onSubmit={handleSubmit}
            disabled={!isFormValid || isSubmitting}
            loading={isSubmitting}
            onDisabled={handleSubmit}
            addClassName="mt-20px"
          />
        </div>
      </div>
    </div>
  )
}

export default ReviewKeywordSuggest
